















































































































































































import { Component, Provide, Vue, Watch } from "vue-property-decorator";
import wxGroupEdit from "../tenantsView/wx-message_GroupEdit.vue"; //群发回复表单

import HttpClient from "@/API/HttpClient";
import Utils from "@/store/utils";
import httpApi from "@/API/Tenant/Weixin";
import { format } from "path";
//import App from "@/components/Global/GetAppData"; //缓存接口
import { log } from "util";
import { WxGroup } from "@/Entity"; //全局常量
import { unlink } from "fs";
import { getCookie } from "@/JS/cookie"; //使用getCookie方法
import Bus from "@/JS/Bus";
@Component({
  components: { wxGroupEdit }
})
export default class extends Vue {
  $message: any;
  //注入数据 @Provide()
  @Provide()
  private pagesize = 10; //每页的数据条数
  private pageIndex = 1; // 默认第一页
  private totalItem = 0; //数据总长度
  private pagesizeLog = 10; //每页的数据条数
  private pageIndexLog = 1; // 默认第一页
  private totalLogItem = 0;
  private Data = {}; //把行信息传到子组件
  private GroupTabData = []; //表格
  private GroupTabDataLog = [];
  private GroupEdit = true; //父子组件的显示和隐藏
  private ReviewDialog = false; //审核群消息对话框是否显示
  private ViewDialog = false; //查看发送结果
  private ReviewData: any = []; //审核数据
  private GroupMessageLogData: any = []; //发送人员日志
  private Keyword: string = ""; //搜索关键词
  private SendType = undefined; //发送方式
  private SendStatus = undefined; //群发状态
  private GetAppData: any = []; //取应用号信息
  private Review = {
    SendStatus: 1,
    ApprovalRemark: "通过"
  };
  //分页方法
  private handleClick() {}
  private handleSizeChange(val: any) {
    this.pagesize = val;
    this.getGroupList();
  }
  private handleCurrentChange(val: any) {
    this.pageIndex = val;
    this.getGroupList();
  }
  changeSendStatus() {
    this.Review.ApprovalRemark = "";
  }
  //详细分页方法

  private handleSizeLogChange(val: any) {
    this.pagesizeLog = val;
    this.getGroupListLog();
  }
  private handleLogCurrentChange(val: any) {
    this.pageIndexLog = val;
    this.getGroupListLog();
  }

  //审核数据
  handleReview(index: any, row: any) {
    this.ReviewDialog = true;
    this.ReviewData = row;
  }
  //取消审核
  Cancle() {
    this.ReviewDialog = false;
    this.getGroupList();
  }

  //保存审核数据
  async ApprovalSubmit() {
    if (this.Review.SendStatus == -1 && !this.Review.ApprovalRemark) {
      this.$message.error("请说明不通过原因！");
      return;
    }
    if (this.Review.SendStatus == 1 && !this.Review.ApprovalRemark) {
      this.$message.error("请说明通过原因！");
      return;
    }
    this.ReviewData.SendStatus = this.Review.SendStatus;
    this.ReviewData.ApprovalRemark = this.Review.ApprovalRemark;
    let params: any = {
      Input: [
        {
          Name: "AppSendMsgConfig",
          Value: this.ReviewData
        }
      ]
    };
    var res: any = await httpApi.UpdateSendStatusSendMsgConfig(params);
    if (res.ErrorCode == 0) {
      this.$message.success("操作成功！");
      this.ReviewDialog = false;
    } else {
      this.$message.error(res.ErrorMessage);
    }
    this.getGroupList();
  }
  //查看发送日志
  async handleView(index: any, row: any) {
    this.ViewDialog = true;
    this.ReviewData = row;
    this.getGroupListLog();
  }
  //格式化时间
  formatDate(row: any, column: any) {
    if (row.SetSendDate != null && row.SetSendDate != "") {
      // var date = new Date(row.SetSendDate);
      // return FomatDataStr.formatTimeToStr(date, "yyyy-MM-dd hh:mm:ss");
      var date = row.SetSendDate;
      date = date.replace("T", " ");
      date = date.substring(0, 16);
      return date;
    } else {
      return "";
    }
  }
  //格式化时间
  formatDateTow(row: any, column: any) {
    if (row.UpdatedTime) {
      // var date = new Date(row.SetSendDate);
      // return FomatDataStr.formatTimeToStr(date, "yyyy-MM-dd hh:mm:ss");
      var date = row.UpdatedTime;
      date = date.replace("T", " ");
      date = date.substring(0, 16);
      return date;
    } else {
      return "";
    }
  }
  formatRemarks(row: any, column: any) {
    if (row.Remarks) {
      return row.Remarks;
    } else {
      return "未发送";
    }
  }
  //格式化匹配度类型
  formatStatus(row: any, column: any) {
    switch (row.SendStatus) {
      case 0:
        return "未审核";
      case 1:
        if (row.SendType == 4) {
          return "运行中";
        } else {
          return "已审核";
        }
        return "";
      case 2:
        return "已经发送";
      case -1:
        return "审核不通过";
      default:
        return "发送失败";
    }
  }
  formatApprovalRemark(row: any, column: any) {
    if (row.SendType == 4 && row.SendStatus == 0) {
      return "请先审核";
    } else {
      return row.ApprovalRemark;
    }
  }
  //格式化匹配度类型
  formatStatusLog(row: any, column: any) {
    switch (row.Status) {
      case 0:
        return "未发送";
      case 1:
        return "已发送";
      case -1:
        return "发送失败";
      default:
        return "未知状态";
    }
  }
  //类型
  formatMsgId(row: any, column: any) {
    if (row.SendType != 4) {
      return row.MsgId;
    } else {
      return "关注后" + row.MsgId + "分钟发送";
    }
  }
  //群发方式
  formatSendType(row: any, column: any) {
    switch (row.SendType) {
      case 1:
        return "分组群发";
      case 2:
        return "指定粉丝";
      case 3:
        return "48小时内互动粉丝";
      case 4:
        return "48小时内关注粉丝";
      case 5:
        return "全部关注粉丝";
      default:
        return "";
    }
  }
  //消息odga
  formatMsgType(row: any, column: any) {
    switch (row.MsgType) {
      case 1:
        return "文本";
      case 2:
        return "图片";
      case 3:
        return "图文";
      case 4:
        return "语音";
      case 5:
        return "视频";
      case 6:
        return "音乐";
      case 10:
        return "永久素材";
      case 99:
        if (row.SendType != 4) {
          return "群发";
        } else {
          return "关注用户群发";
        }
      default:
        return "";
    }
  }
  //表单过来的刷新方法
  refresh() {
    this.getGroupList();
    this.GroupEdit = true;
  }
  //初始化
  created() {
    let Aid = getCookie("Aid");
    let TenantID = getCookie("TenantID");
    this.GetAppData = {
      Aid: Aid,
      TenantID: TenantID
    };
    var that = this;
    Bus.$off("switchAccountFn");
    Bus.$on("switchAccountFn", (obj: any) => {
      that.GetAppData.Aid = obj.Aid;
      that.getGroupList();
    });
    this.getGroupList();
  }

  //编辑
  handleEdit(index: any, row: any) {
    this.Data = row; //把行信息传给data
    this.GroupEdit = false;
  }
  //新增文本方法
  AddGroupEdit() {
    this.GroupEdit = false;
    this.Data = new WxGroup();
  }
  //加载表格数据
  //加载数据
  async getGroupList() {
    var _this = this;
    //console.log(this.GetAppData);
    let AppAccount = this.GetAppData;
    if (AppAccount) {
      //搜索的数据 传参
      let params: any = {
        Input: [
          { Name: "Aid", value: AppAccount.Aid },
          { Name: "Keyword", value: this.Keyword },
          //分页参数
          { Name: "page", value: this.pageIndex },
          { Name: "rows", value: this.pagesize }
        ]
      };
      if (this.SendType) {
        params.Input.push({ Name: "SendType", value: this.SendType });
      }
      if (this.SendStatus) {
        params.Input.push({ Name: "SendStatus", value: this.SendStatus });
      }
      //console.log(params);
      var res: any = await httpApi.GetGroup(params);
      if (res.ErrorCode == 0) {
        _this.GroupTabData = res.output[0].value;
        //console.log("群发消息", _this.GroupTabData);
        _this.totalItem = res.output[1].value; // _this.GroupTabData.length;
      } else {
        this.$message.error(res.ErrorMessage);
      }
    }
  }
  //加载详细数据
  async getGroupListLog() {
    let params: any = {
      Input: [
        {
          Name: "AppSendMsgPeopleDTO",
          Value: {
            TenantId: this.ReviewData.TenantId,
            ApplicationId: this.ReviewData.ApplicationId,
            GatherId: this.ReviewData.GatherId
          }
        }, //分页参数
        { Name: "page", value: this.pageIndexLog },
        { Name: "rows", value: this.pagesizeLog }
      ]
    };
    //console.log(params);
    var res: any = await httpApi.GroupMessageLog(params);
    if (res.ErrorCode == 0) {
      console.log(res);
      this.GroupMessageLogData = res.output[0].value;
    } else {
      this.$message.error(res.ErrorMessage);
    }
    this.totalLogItem = res.output[1].value;
  }
  //单行删除
  async handleDel(index: any, row: any) {
    this.$confirm("确定要删除当前数据吗?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning"
    }).then(async () => {
      let model = row as WxGroup; //把行内信息转换成wxText
      var _this = this;
      let AppAccount = this.GetAppData;

      if (AppAccount) {
        model.ApplicationId = AppAccount.Aid;
        model.TenantId = AppAccount.TenantID;
        model.ActionName = "DELETE";
        let params: any = {
          Input: [
            {
              Name: "AppSendMsgConfigDTO",
              value: model
            }
          ]
        };
        var res: any = await httpApi.SaveGroup(params);
        if (res.ErrorCode == 0) {
          this.$message.success("删除成功!");
          this.getGroupList();
        } else {
          this.$message.error("删除失败：" + res.ErrorMessage);
        }
      }
    });
    return new WxGroup();
  }
}
